import { useApolloClient } from "@apollo/client";
import { useAsyncExecutor2 } from "async-executor-hook";
import { addDays, format } from "date-fns";
import { map } from "rxjs";

import { useQueryParams$ } from "../../common/hooks/useQueryParams$";
import { getDateAttribute } from "../../common/searchParams.utils";
import { AdminComplaintsSearch } from "../AdminComplaintsSearch/AdminComplaintsSearch";
import { AdminComplaintsTable } from "../AdminComplaintsTable/AdminComplaintsTable";
import { Container } from "./AdminComplaintsStyles";
import requestData from "./requestData";
import { ComplaintDoc, LoadComplaintsParams } from "./types";

export const AdminComplaintsResource = () => {
  const params$ = useQueryParams$().pipe(
    map((params: any) => {
      const enterDate = getDateAttribute(
        params.enterDate,
        addDays(new Date(), -60)
      );
      return { ...params, enterDate };
    })
  );

  const client = useApolloClient();

  const loadComplaints = useAsyncExecutor2<LoadComplaintsParams, ComplaintDoc>(
    (params) => {
      const {
        page,
        caseNumber,
        status,
        enterDate,
        area,
        clientName,
        category,
      } = params;

      const networkOnly = true;
      return requestData(
        client,
        page,
        caseNumber,
        status,
        enterDate,
        area,
        clientName,
        category,
        networkOnly
      ).then((resp) => {
        return resp.getAllDemand;
      });
    },

    {
      params$: params$.pipe(
        map((params) => {
          return {
            ...params,
            enterDate: format(params.enterDate, "yyyy-MM-dd"),
            page: params.page ? parseInt(params.page) : 1,
          };
        })
      ),
    }
  );

  return (
    <Container>
      <AdminComplaintsSearch params$={params$} />
      <AdminComplaintsTable loadComplaints={loadComplaints} />
    </Container>
  );
};
